<!-- 别说话，直接doc转html然后Ctrl + C and Ctrl + V-->
<template>
  <div>
    <div class="segment-wrap">
      <span class="group-title">质量承诺</span>
      <div class="cell-group-wrap" style=" font-size: 12px; padding: 0 20px">
        <p><span>1、蛋白组学去高丰度蛋白、TMT蛋白组学6标及以上、label free蛋白组学、PRM实验方法评估和建立、PRM蛋白组学检测、石蜡样本蛋白组学、DIA建库（12级）、大样本蛋白质组DIA分析、DIA蛋白组学检测、DIA建库（6级）、DIA 2.0蛋白组学检测、4D label free蛋白组学</span><br/><span
        >•上述所有服务项目均为提供客观实验结果。</span><br/><span
        >2、蛋白组学生信分析（A套系）</span><br/><span>•数据质量评估后，如不符合继续分析标准，则中止后续分析，进入客户交流阶段，交流确认的周期不计入合同执行周期内；</span><br/><span
        >•所示周期为一组分析的周期，如有多组分析则周期累加。</span><br/><span>3、shotgun蛋白组学检测</span><br/><span
        >•提供每个样本的定性质谱和蛋白质查库的客观实验结果（不包括样本间的比较分析）。</span><br/><span
        >4、DeepDIA</span><br/><span
        >•提供客观真实的实验结果。</span><br/><span
        >5、微量样本蛋白提取（组织/细胞）</span><br/><span>•按照SOP操作流程进行蛋白提取，提供蛋白定量结果，保证数据客观、真实。</span>
        </p>
      </div>
    </div>
    <div class="segment-wrap">
      <span class="group-title">服务说明</span>
      <div class="cell-group-wrap" style=" font-size: 12px; padding:0 20px">
        <p><span>1、TMT蛋白组学6标及以上、label free蛋白组学</span><br/><span
        >•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。 若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。</span><br/><span
        >•根据 iTRAQ/TMT 的技术特性，乙方采用差异倍数FC≥1.2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >2、蛋白组学生信分析（A套系）</span><br/><span>•数据质量评估后，如不符合继续分析标准，则中止后续分析，进入客户交流阶段，交流确认的周期不计入合同执行周期内；</span><br/><span
        >•所示周期为一组分析的周期，如有多组分析则周期累加。</span><br/><span>3、PRM实验方法评估和建立、PRM蛋白组学检测</span><br/><span
        >•样本制备、方法评估以及正式实验先后进行，周期累计，若前期实验不成功，合同终止，收取已完成部分的费用。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >4、shotgun蛋白组学检测</span><br/><span>•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。</span><br/><span
        >•跟据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >5、DeepDIA</span><br/><span>•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行</span><span
        >后续实验。</span><br/><span>•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >6、石蜡样本蛋白组学</span><br/><span>•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。</span><br/><span
        >•根据label free的技术特性，乙方采用差异倍数FC≥2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。</span><br/><span
        >7、DIA建库（12级）、DIA蛋白组学检测、DIA建库（6级）</span><br/><span>•预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传</span><br/><span
        >染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >8、大样本蛋白质组DIA分析</span><br/><span>•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常，会与乙方交流确定后进行后续实验。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方有权单方面直接解除合同，并立即通知相关部门处置该等样本，并要求甲方赔偿相应损失。</span><br/><span
        >9、DIA 2.0蛋白组学检测</span><br/><span>•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。</span><br/><span
        >•血清/血浆、石蜡样本，甲方无特殊要求，默认选择用Exploris 480分析，其他类型样本，乙方根据实验条件自行选择timsTOF Pro或Exploris 480进行分析。若甲方有特殊要求，需提前与乙方沟通协商，达成一致；</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传</span><br/><span
        >染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >10、4D label free蛋白组学</span><br/><span>•甲方提供的样本经乙方预实验检验合格后开启正式实验，预实验与正式实验先后进行，周期自预实验启动时计算，若预实验不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。</span><br/><span
        >•根据 4D label free 的技术特性，乙方采用差异倍数FC≥2 倍，P 值≤0.05标准筛选差异蛋白并进行后续分析。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >11、微量样本蛋白提取（组织/细胞）</span><br/><span>•微量样本蛋白提取后进行蛋白定量，若在抽提过程发现异常情况，或因原始送样量太少导致蛋白抽提不足，与乙方交流确定后，按达成一致的办法进行处理。若无异常且蛋白量足够，则直接启动后续实验。</span><br/><span
        >•若蛋白抽提异常或不成功，且双方同意终止合同的，乙方仍需收取已完成部分的费用。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span><br/><span
        >•微量样本蛋白提取为预实验。预实验与正式实验先后进行，周期累计，若预实验不成功，合同终止，收取已完成部分的费用。若预实验正常就直接进行后续实验，若异常或有可选内容（比如多个细胞选择一株），会与乙方交流确定后进行后续实验。</span><br/><span
        >•根据相关法律法规，传染性生物样本需要严格管控，乙方目前不具备处理传染性样本的实验条件，故甲方务必保证提供的生物样本为非传</span><br/><span
        >染性样本；若一旦发现甲方提供的生物样本具有传染性，乙方将保留追究相应的刑事和民事责任的权利。</span></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaticDoc'
}
</script>

<style scoped>
.segment-wrap {
  margin: 0 10px;
}

.group-title {
  padding: 0 10px;
  font-family: PingFangSC-Regular;
  font-weight: lighter;
  font-size: 16px;
  line-height: 10px;
  text-align: center;
}

.cell-group-wrap {
  padding: 0 0;
  background-color: #ffffff;
  border-radius: 10px;
}
</style>




// WEBPACK FOOTER //
// StaticDoc.vue?2868d88c